import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";

export {init}
Html.registerWidget('widget/copycontent',{init:init})

function init(obj){
  obj.on('click',function(){
    var 
      input = document.createElement('input');
    
    input.type="text";
    input.value=obj.text();
    document.body.appendChild(input)
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    modal.toast({text:'actions.copied',emoji:'👍'})
  })
}